import axios from 'axios';
import config from '../common/config';

export default {
  submitContactForm(formData) {
    const data = new FormData();
    data.append('data', JSON.stringify(formData));
    
    return axios.post(`${config.config.ROOT_URL}/contact_form_api`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }).then(response => {
      return response.data;
    }).catch(error => {
      console.error('Contact form API error:', error);
      throw error;
    });
  }
};

